const hiddeLabelToltip = (input) =>{
    input.parentNode.querySelector('.toltip').classList.add('focus');
    input.parentNode.querySelector('label').classList.add('focus')
}
const showLabelToltip = (input) =>{
    input.parentNode.querySelector('.toltip').classList.remove('focus');
    input.parentNode.querySelector('label').classList.remove('focus')
}
const customReset =(form)=>{
    let inputs = form.querySelectorAll('input');
    form.reset();
    inputs.forEach(input=>{
        input.setAttribute('data-number', '');
    })
}
const setNumberAttribute =(input, value)=>{
    input.setAttribute('data-number', value);
}
const pfrtCalculator = (formpfrt, pfrtSCFMInput, pfrtΔTInput, pfrtWattsInput, pfrtBtnReset) => {
    formpfrt.addEventListener('submit', e => {
        e.preventDefault();
        let originalSCFM = parseFloat(pfrtSCFMInput.getAttribute('data-number'));
        let originalΔT = parseFloat(pfrtΔTInput.getAttribute('data-number'));
        let originalWatts = parseFloat(pfrtWattsInput.getAttribute('data-number'));
        if(isNaN(originalSCFM)){
            originalSCFM = parseFloat(pfrtSCFMInput.value);
        };
        if(isNaN(originalΔT)){
            originalΔT = parseFloat(pfrtΔTInput.value);
        };
        if(isNaN(originalWatts)){
            originalWatts = parseFloat(pfrtWattsInput.value);
        };

        // Calcula SCFM
        if (!isNaN(originalΔT) && !isNaN(originalWatts)) {
            const pfrtcalculatedSCFM = (originalWatts * 2.5) / originalΔT;
            if (!isNaN(pfrtcalculatedSCFM)) {
                pfrtSCFMInput.value = pfrtcalculatedSCFM.toFixed(0  );
                hiddeLabelToltip(pfrtSCFMInput);
                pfrtSCFMInput.setAttribute('data-number', pfrtcalculatedSCFM);
            } else {
                pfrtSCFMInput.value = '';
            }
        }
        // Calcula ΔT
        else if (!isNaN(originalSCFM) && !isNaN(originalWatts)) {
            const pfrtcalculatedΔT = (originalWatts * 2.5) / originalSCFM;
            if (!isNaN(pfrtcalculatedΔT)) {
                pfrtΔTInput.value = pfrtcalculatedΔT.toFixed(0);
                hiddeLabelToltip(pfrtΔTInput);
                pfrtΔTInput.setAttribute('data-number', pfrtcalculatedΔT);
            } else {
                pfrtΔTInput.value = '';
            }
        }
        // Calcula Watts
        else if (!isNaN(originalSCFM) && !isNaN(originalΔT)) {
            const pfrtcalculatedWatts = (originalSCFM * originalΔT) / 2.5;
            if (!isNaN(pfrtcalculatedWatts)) {
                pfrtWattsInput.value = pfrtcalculatedWatts.toFixed(0);
                hiddeLabelToltip(pfrtWattsInput);
                pfrtWattsInput.setAttribute('data-number', pfrtcalculatedWatts);
            } else {
                pfrtWattsInput.value = '';
            }
        }
    });

    pfrtBtnReset.addEventListener('click', e => {
        console.log('click reset');
        customReset(formpfrt);
    });
};

const tcCalculator = (formtc, tcFInput, tcCInput, tcBtnReset) => {
    customReset(formtc);
    let lastInput = '';
    tcFInput.addEventListener('input', e=>{
        lastInput = 'f';
        console.log(lastInput);
    })
    tcCInput.addEventListener('input', e=>{
        lastInput = 'c';
        console.log(lastInput);
    })
    formtc.addEventListener('submit', e => {
        e.preventDefault();
        let tcF = parseFloat(tcFInput.getAttribute('data-number'));
        let tcC = parseFloat(tcCInput.getAttribute('data-number'));

        if(isNaN(tcF)){
            tcF = parseFloat(tcFInput.value);
        };
        if(isNaN(tcC)){
            tcC = parseFloat(tcCInput.value);
        };

        if (!isNaN(tcF) && isNaN(tcC)) {
            const calculatedC = (tcF - 32) * (5/9);
            if (!isNaN(calculatedC)) {
                tcCInput.value = calculatedC.toFixed(0);
                hiddeLabelToltip(tcCInput);
                tcCInput.setAttribute('data-number', calculatedC);
            } else {
                tcCInput.value = '';
            }
        } else if (!isNaN(tcC) && isNaN(tcF)) {
            const calculatedF = (tcC * (9/5)) + 32;
            if (!isNaN(calculatedF)) {
                tcFInput.value = calculatedF.toFixed(0);
                hiddeLabelToltip(tcFInput);
                tcFInput.setAttribute('data-number', calculatedF);
            } else {
                tcFInput.value = '';
            }
        } else if(!isNaN(tcC) && !isNaN(tcF)){
            //calcular el ultimo input editado
            console.log('ambos estan llenos');
            console.log(lastInput);
            if(lastInput == 'f'){
                const calculatedC = (tcF - 32) * (5/9);
                if (!isNaN(calculatedC)) {
                    tcCInput.value = calculatedC.toFixed(0);
                    hiddeLabelToltip(tcCInput);
                    tcCInput.setAttribute('data-number', calculatedC);
                } else {
                    tcCInput.value = '';
                }
            }else if(lastInput == 'c'){
                const calculatedF = (tcC * (9/5)) + 32;
                if (!isNaN(calculatedF)) {
                    tcFInput.value = calculatedF.toFixed(0);
                    hiddeLabelToltip(tcFInput);
                    tcFInput.setAttribute('data-number', calculatedF);
                } else {
                    tcFInput.value = '';
                }
            }
        }
    });

    tcBtnReset.addEventListener('click', e => {
        customReset(formtc);
    });
}
const tpucCalculator = (formtpuc, tpucWattsInput, tpucVoltageInput, tpucLineCurrentInput, tpucBtnReset) => {
    formtpuc.addEventListener('submit', e => {
        e.preventDefault();

        let tpucWatts = parseFloat(tpucWattsInput.getAttribute('data-number'));
        let tpucVoltage = parseFloat(tpucVoltageInput.getAttribute('data-number'));
        let tpucLineCurrent = parseFloat(tpucLineCurrentInput.getAttribute('data-number'));

        if (isNaN(tpucWatts)) {
            tpucWatts = parseFloat(tpucWattsInput.value);
        };
        if (isNaN(tpucVoltage)) {
            tpucVoltage = parseFloat(tpucVoltageInput.value);
        };
        if (isNaN(tpucLineCurrent)) {
            tpucLineCurrent = parseFloat(tpucLineCurrentInput.value);
        };

        if (!isNaN(tpucWatts) && !isNaN(tpucVoltage)) {
            const calculatedLineCurrent = tpucWatts / (Math.sqrt(3) * tpucVoltage);
            if (!isNaN(calculatedLineCurrent)) {
                tpucLineCurrentInput.value = calculatedLineCurrent.toFixed(4);
                hiddeLabelToltip(tpucLineCurrentInput);
                tpucLineCurrentInput.setAttribute('data-number', calculatedLineCurrent);
            } else {
                tpucLineCurrentInput.value = '';
            }
        } else if (!isNaN(tpucWatts) && !isNaN(tpucLineCurrent)) {
            const calculatedVoltage = tpucWatts / (Math.sqrt(3) * tpucLineCurrent);
            if (!isNaN(calculatedVoltage)) {
                tpucVoltageInput.value = calculatedVoltage.toFixed(0);
                hiddeLabelToltip(tpucVoltageInput);
                tpucVoltageInput.setAttribute('data-number', calculatedVoltage);
            } else {
                tpucVoltageInput.value = '';
            }
        } else if (!isNaN(tpucVoltage) && !isNaN(tpucLineCurrent)) {
            const calculatedWatts = tpucVoltage * tpucLineCurrent * Math.sqrt(3);
            if (!isNaN(calculatedWatts)) {
                tpucWattsInput.value = calculatedWatts.toFixed(0);
                hiddeLabelToltip(tpucWattsInput);
                tpucWattsInput.setAttribute('data-number', calculatedWatts);
            } else {
                tpucWattsInput.value = '';
            }
        }
    });
    
    tpucBtnReset.addEventListener('click', e => {
        customReset(formtpuc);
    });
}
const spucCalculator = (formspuc, spucWattsInput, spucVoltageInput, spucLineCurrentInput, spucBtnReset) => {
    formspuc.addEventListener('submit', e => {
        e.preventDefault();
        let spucWatts = parseFloat(spucWattsInput.getAttribute('data-number'));
        let spucVoltage = parseFloat(spucVoltageInput.getAttribute('data-number'));
        let spucLineCurrent = parseFloat(spucLineCurrentInput.getAttribute('data-number'));
        if (isNaN(spucWatts)) {
            spucWatts = parseFloat(spucWattsInput.value);
        };
        if (isNaN(spucVoltage)) {
            spucVoltage = parseFloat(spucVoltageInput.value);
        };
        if (isNaN(spucLineCurrent)) {
            spucLineCurrent = parseFloat(spucLineCurrentInput.value);
        };

        if (!isNaN(spucWatts) && !isNaN(spucVoltage)) {
            const calculatedLineCurrent = spucWatts / spucVoltage;
            if (!isNaN(calculatedLineCurrent)) {
                spucLineCurrentInput.value = calculatedLineCurrent.toFixed(4);
                hiddeLabelToltip(spucLineCurrentInput);
                spucLineCurrentInput.setAttribute('data-number', calculatedLineCurrent);
            } else {
                spucLineCurrentInput.value = '';
            }
        } else if (!isNaN(spucWatts) && !isNaN(spucLineCurrent)) {
            const calculatedVoltage = spucWatts / spucLineCurrent;
            if (!isNaN(calculatedVoltage)) {
                spucVoltageInput.value = calculatedVoltage.toFixed(0);
                hiddeLabelToltip(spucVoltageInput);
                spucVoltageInput.setAttribute('data-number', calculatedVoltage);
            } else {
                spucVoltageInput.value = '';
            }
        } else if (!isNaN(spucVoltage) && !isNaN(spucLineCurrent)) {
            const calculatedWatts = spucVoltage * spucLineCurrent;
            if (!isNaN(calculatedWatts)) {
                spucWattsInput.value = calculatedWatts.toFixed(0);
                hiddeLabelToltip(spucWattsInput);
                spucWattsInput.setAttribute('data-number', calculatedWatts);
            } else {
                spucWattsInput.value = '';
            }
        }
    });
    spucBtnReset.addEventListener('click', e => {
        customReset(formspuc);
    });
}


const httcCalculator = (formhttc, httcDensityInput, httcVolumeInput, httcSpecificHeatInput, httcTemperatureDiffInput, httcQInput, httcBtnReset) => {
    // Inicializar los atributos data-number cuando se carga la página
    customReset(formhttc);

    formhttc.addEventListener('submit', e => {
        e.preventDefault();
        let httcQ = parseFloat(httcQInput.getAttribute('data-number'));
        let httcDensity = parseFloat(httcDensityInput.getAttribute('data-number'));
        let httcVolume = parseFloat(httcVolumeInput.getAttribute('data-number'));
        let httcSpecificHeat = parseFloat(httcSpecificHeatInput.getAttribute('data-number'));
        let httcTemperatureDiff = parseFloat(httcTemperatureDiffInput.getAttribute('data-number'));

        if (isNaN(httcQ)) {
            httcQ = parseFloat(httcQInput.value);
        };
        if (isNaN(httcDensity)) {
            httcDensity = parseFloat(httcDensityInput.value);
        };
        if (isNaN(httcVolume)) {
            httcVolume = parseFloat(httcVolumeInput.value);
        };
        if (isNaN(httcSpecificHeat)) {
            httcSpecificHeat = parseFloat(httcSpecificHeatInput.value);
        };
        if (isNaN(httcTemperatureDiff)) {
            httcTemperatureDiff = parseFloat(httcTemperatureDiffInput.value);
        };

        // Calcula ρ
        if (!isNaN(httcQ) && !isNaN(httcVolume) && !isNaN(httcSpecificHeat) && !isNaN(httcTemperatureDiff)) {
            const calculatedDensity = httcQ / (httcVolume * httcSpecificHeat * httcTemperatureDiff);
            if (!isNaN(calculatedDensity)) {
                httcDensityInput.value = calculatedDensity.toFixed(4);
                hiddeLabelToltip(httcDensityInput);
                httcDensityInput.setAttribute('data-number', calculatedDensity);
            } else {
                httcDensityInput.value = '';
            }
        }
        
        // V
        if (!isNaN(httcQ) && !isNaN(httcDensity) && !isNaN(httcSpecificHeat) && !isNaN(httcTemperatureDiff)) {
            const calculatedVolume = httcQ / (httcDensity * httcSpecificHeat * httcTemperatureDiff);
            if (!isNaN(calculatedVolume)) {
                httcVolumeInput.value = calculatedVolume.toFixed(4);
                hiddeLabelToltip(httcVolumeInput);
                httcVolumeInput.setAttribute('data-number', calculatedVolume);
            } else {
                httcVolumeInput.value = '';
            }
        }

        // Cp
        if (!isNaN(httcQ) && !isNaN(httcDensity) && !isNaN(httcVolume) && !isNaN(httcTemperatureDiff)) {
            const calculatedSpecificHeat = httcQ / (httcDensity * httcVolume * httcTemperatureDiff);
            if (!isNaN(calculatedSpecificHeat)) {
                httcSpecificHeatInput.value = calculatedSpecificHeat.toFixed(4);
                hiddeLabelToltip(httcSpecificHeatInput);
                httcSpecificHeatInput.setAttribute('data-number', calculatedSpecificHeat);
            } else {
                httcSpecificHeatInput.value = '';
            }
        }

        // Ta-Tb
        if (!isNaN(httcQ) && !isNaN(httcDensity) && !isNaN(httcVolume) && !isNaN(httcSpecificHeat)) {
            const calculatedTemperatureDiff = httcQ / (httcDensity * httcVolume * httcSpecificHeat);
            if (!isNaN(calculatedTemperatureDiff)) {
                httcTemperatureDiffInput.value = calculatedTemperatureDiff.toFixed(4);
                hiddeLabelToltip(httcTemperatureDiffInput);
                httcTemperatureDiffInput.setAttribute('data-number', calculatedTemperatureDiff);
            } else {
                httcTemperatureDiffInput.value = '';
            }
        }

        //Q
        if (!isNaN(httcDensity) && !isNaN(httcVolume) && !isNaN(httcSpecificHeat) && !isNaN(httcTemperatureDiff)) {
            const calculatedQ = httcDensity * httcVolume * httcSpecificHeat * httcTemperatureDiff;
            if (!isNaN(calculatedQ)) {
                httcQInput.value = calculatedQ.toFixed(4);
                hiddeLabelToltip(httcQInput);
                httcQInput.setAttribute('data-number', calculatedQ);
            } else {
                httcQInput.value = '';
            }
        }
    });

    httcBtnReset.addEventListener('click', e => {
        customReset(formhttc);
    });
}
const sfrCalculator = (formsfr, sfrCFMInput, sfrPSIInput, sfrTInput, sfrSCFMInput, sfrBtnReset) => {

    formsfr.addEventListener('input', e => {
        e.preventDefault();
        let sfrCFM = parseFloat(sfrCFMInput.getAttribute('data-number'));
        let sfrPSI = parseFloat(sfrPSIInput.getAttribute('data-number'));
        let sfrT = parseFloat(sfrTInput.getAttribute('data-number'));
        if (isNaN(sfrCFM)) {
            sfrCFM = parseFloat(sfrCFMInput.value);
        };
        if (isNaN(sfrPSI)) {
            sfrPSI = parseFloat(sfrPSIInput.value);
        };
        if (isNaN(sfrT)) {
            sfrT = parseFloat(sfrTInput.value);
        };

        // Calcula SCFM
        if (!isNaN(sfrCFM) && !isNaN(sfrPSI) && !isNaN(sfrT)) {
            console.log('test calculo');
            let TActual =  sfrT + 460;
            let PSIActual = sfrPSI + 14.7;
            const sfrSCFM = sfrCFM * (PSIActual / 14.7) * (528 / TActual);
            if (!isNaN(sfrSCFM)) {
                sfrSCFMInput.value = sfrSCFM.toFixed(4);
                hiddeLabelToltip(sfrSCFMInput);
                sfrSCFMInput.setAttribute('data-number', sfrSCFM);
            } else {
                sfrSCFMInput.value = '';
            }
        }
    });

    formsfr.addEventListener('submit', e => {
        e.preventDefault();
        let sfrCFM = parseFloat(sfrCFMInput.getAttribute('data-number'));
        let sfrPSI = parseFloat(sfrPSIInput.getAttribute('data-number'));
        let sfrT = parseFloat(sfrTInput.getAttribute('data-number'));
        if (isNaN(sfrCFM)) {
            sfrCFM = parseFloat(sfrCFMInput.value);
        };
        if (isNaN(sfrPSI)) {
            sfrPSI = parseFloat(sfrPSIInput.value);
        };
        if (isNaN(sfrT)) {
            sfrT = parseFloat(sfrTInput.value);
        };

        // Calcula SCFM
        if (!isNaN(sfrCFM) && !isNaN(sfrPSI) && !isNaN(sfrT)) {
            let TActual =  460 + sfrT;
            let PSIActual = sfrPSI + 14.7;
            const sfrSCFM = sfrCFM * (PSIActual / 14.7) * (528 / TActual);
            if (!isNaN(sfrSCFM)) {
                sfrSCFMInput.value = sfrSCFM.toFixed(4);
                hiddeLabelToltip(sfrSCFMInput);
                sfrSCFMInput.setAttribute('data-number', sfrSCFM);
            } else {
                sfrSCFMInput.value = '';
            }
        }
    });

    sfrBtnReset.addEventListener('click', e => {
        customReset(formsfr);
    });
}
  
const pressureConverter = (formPb, pbPSIInput, pbBarInput, pbBtnReset) => {

    formPb.addEventListener('submit', e => {
        e.preventDefault();
        let psi = parseFloat(pbPSIInput.getAttribute('data-number'));
        let bar = parseFloat(pbBarInput.getAttribute('data-number'));
        if (isNaN(psi)) {
            psi = parseFloat(pbPSIInput.value);
        };
        if (isNaN(bar)) {
            bar = parseFloat(pbBarInput.value);
        };

        if (!isNaN(psi)) {
            const barValue = psi / 14.504;
            pbBarInput.value = barValue.toFixed(4);
            hiddeLabelToltip(pbBarInput);
            pbBarInput.setAttribute('data-number', barValue);
        } else if (!isNaN(bar)) {
            const psiValue = bar * 14.504;
            pbPSIInput.value = psiValue.toFixed(4);
            hiddeLabelToltip(pbPSIInput);
            pbPSIInput.setAttribute('data-number', psiValue);
        }
    });

    pbBtnReset.addEventListener('click', e => {
        customReset(formPb);
    });
}

const ohmsCalculator = (formOlc, olcOhmsInput, olcVoltsInput, olcAmpsInput, olcWattsInput, btnReset) => {
    let lastInput = '';
    olcOhmsInput.addEventListener('input', e=>{
        console.log(lastInput);
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }
        //calcular todos menos ohms

        const calculateVoltsAmpsWithOhmsWatts = (ohms, watts) =>{
            let resultVolts = Math.sqrt(watts * ohms).toFixed(4);
            let resultAmps = Math.sqrt(watts / ohms).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcAmpsInput.value = resultAmps;
            hiddeLabelToltip(olcVoltsInput);
            hiddeLabelToltip(olcAmpsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcAmpsInput, resultAmps);
            console.log('calculando volts amps');
        }
        const calculateVoltsWattsWithOhmsAmps = (ohms, amps) =>{
            let resultVolts = (amps * ohms).toFixed(4);
            let resultWatts = (amps ** 2 * ohms).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcWattsInput.value = resultWatts;
            hiddeLabelToltip(olcVoltsInput);
            hiddeLabelToltip(olcWattsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcWattsInput, resultWatts);
            console.log('calculando volts watts');
        }
        const calculateAmpsWattsWithOhmsVolts = (ohms, volts) =>{ //revisar
            let resultAmps = (volts / ohms).toFixed(4);
            let resultWatts = (volts ** 2 / ohms).toFixed(4);
            olcAmpsInput.value = resultAmps;
            olcWattsInput.value = resultWatts
            hiddeLabelToltip(olcAmpsInput);
            hiddeLabelToltip(olcWattsInput);
            setNumberAttribute(olcAmpsInput, resultAmps);
            setNumberAttribute(olcWattsInput, resultWatts);
            console.log('calculando Amps watts');
        }
        if (!isNaN(ohms) && !isNaN(watts) && isNaN(volts) && isNaN(amps)) {
            //calcular volts y amps
            calculateVoltsAmpsWithOhmsWatts(ohms, watts);
        } else if (!isNaN(ohms) && !isNaN(amps)  && isNaN(volts) && isNaN(watts)) {
            //calcular volts y watts
            calculateVoltsWattsWithOhmsAmps(ohms, amps);

        } else if (!isNaN(ohms) && !isNaN(volts) && isNaN(amps) && isNaN(watts)) {
            //calcular amps y watts
            calculateAmpsWattsWithOhmsVolts(ohms, volts);

        } else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }

            olcAmpsInput.value = (volts / ohms).toFixed(4);
            olcWattsInput.value = (volts ** 2 / ohms).toFixed(4);
        }
        lastInput = 'ohms';
        
    })
    olcVoltsInput.addEventListener('input', e=>{
        
        //console.log('escribiendo volts');
        console.log(lastInput);

        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }

        calculateOhmsWattsWithVoltsAmps = (volts, amps) =>{ //verificado
            let resultOhms = (volts / amps).toFixed(4);
            let resultWatts =(volts * amps).toFixed(4);
            olcOhmsInput.value = resultOhms;
            olcWattsInput.value = resultWatts;
            hiddeLabelToltip(olcOhmsInput);
            hiddeLabelToltip(olcWattsInput);
            setNumberAttribute(olcOhmsInput, resultOhms);
            setNumberAttribute(olcWattsInput, resultWatts);
            console.log('calculando ohms watts');
        }
        calculateOhmsAmpsWithVoltsWatts = (volts, watts) =>{
            let resultOhms = (volts ** 2 / watts).toFixed(4);
            let resultAmps = (watts / volts).toFixed(4);
            olcOhmsInput.value = resultOhms;
            olcAmpsInput.value = resultAmps;
            hiddeLabelToltip(olcOhmsInput);
            hiddeLabelToltip(olcAmpsInput);
            setNumberAttribute(olcOhmsInput, resultOhms);
            setNumberAttribute(olcAmpsInput, resultAmps);
            console.log('calculando ohms amps');
        }
        calculateAmpsWattsWithVoltsOhms = (volts, ohms) =>{ //revisar
            console.log('escribiendo');
            console.log(olcVoltsInput.value);
            let resultAmps = (volts / ohms).toFixed(4);
            let resultWatts =(volts ** 2 / ohms).toFixed(4);
            olcAmpsInput.value = resultAmps;
            olcWattsInput.value = resultWatts;
            hiddeLabelToltip(olcWattsInput);
            hiddeLabelToltip(olcAmpsInput);
            setNumberAttribute(olcWattsInput, resultWatts);
            setNumberAttribute(olcAmpsInput, resultAmps);
            console.log('calculando amps watts');
        }
        if (!isNaN(volts) && !isNaN(amps) && isNaN(ohms) && isNaN(watts)) {
            calculateOhmsWattsWithVoltsAmps(volts, amps);
        } 
        else if (!isNaN(volts) && !isNaN(watts) && isNaN(ohms) && isNaN(amps)) {
            calculateOhmsAmpsWithVoltsWatts(volts, watts);
        } 
        else if (!isNaN(ohms) && !isNaN(volts) && isNaN(watts) && isNaN(amps)) {
            calculateAmpsWattsWithVoltsOhms(volts, ohms);
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateAmpsWattsWithVoltsOhms(volts, ohms);
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts); 
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps);
            }
             
        }
        lastInput = 'volts';
    })
    olcAmpsInput.addEventListener('input',e=>{
        console.log(lastInput);
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }

        const calculateOhmsWattsWithVoltsAmps = (volts, amps) =>{ //verificado
            let resultOhms = (volts / amps).toFixed(4);
            let resultWatts = (volts * amps).toFixed(4);
            olcOhmsInput.value = resultOhms;
            olcWattsInput.value = resultWatts
            hiddeLabelToltip(olcOhmsInput);
            hiddeLabelToltip(olcWattsInput);
            setNumberAttribute(olcOhmsInput, resultOhms);
            setNumberAttribute(olcWattsInput, resultWatts);
            console.log('calculando ohms watts');
        }
        const calculateOhmsVoltsWithWattsAmps = (amps, watts) =>{
            let resultVolts = (watts / amps).toFixed(4);
            let resultOhms = (watts / (amps ** 2)).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcOhmsInput.value = resultOhms;
            hiddeLabelToltip(olcVoltsInput);
            hiddeLabelToltip(olcOhmsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcOhmsInput, resultOhms);
            console.log('calculando volts ohms');
        }
        const calculateWattsVoltsWithOhmsAmps = (amps, ohms) =>{
            let resultVolts = (amps * ohms).toFixed(4);
            let resultWatts = (amps ** 2 * ohms).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcWattsInput.value = resultWatts;
            hiddeLabelToltip(olcWattsInput);
            hiddeLabelToltip(olcVoltsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcWattsInput, resultWatts);
            console.log('calculando volts watts');
        }
        if (!isNaN(volts) && !isNaN(amps) && isNaN(ohms) && isNaN(watts)) {
            calculateOhmsWattsWithVoltsAmps(volts, amps);
        } 
        else if (!isNaN(watts) && !isNaN(amps) && isNaN(ohms) && isNaN(volts)) {
            calculateOhmsVoltsWithWattsAmps(amps, watts);
        } 
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && isNaN(volts)) {
            calculateWattsVoltsWithOhmsAmps(amps, ohms);
        } 
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateWattsVoltsWithOhmsAmps(amps, ohms);
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps);
            }
             
        }
        lastInput = 'amps';
    })
    olcWattsInput.addEventListener('input', e=>{
        console.log(lastInput);
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }


        if (!isNaN(watts) && !isNaN(amps) && isNaN(ohms) && isNaN(volts)) {
            let resultVolts = (watts / amps).toFixed(4);
            let resultOhms = (watts / (amps ** 2)).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcOhmsInput.value = resultOhms;
            hiddeLabelToltip(olcOhmsInput);
            hiddeLabelToltip(olcVoltsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcOhmsInput, resultOhms);
            console.log('calculando volts ohms');
        } 
        else if (!isNaN(volts) && !isNaN(watts) && isNaN(ohms) && isNaN(amps)) {
            let resultOhms = (volts ** 2 / watts).toFixed(4);
            let resultAmps = (watts / volts).toFixed(4);
            olcOhmsInput.value = resultOhms;
            olcAmpsInput.value = resultAmps;
            hiddeLabelToltip(olcOhmsInput);
            hiddeLabelToltip(olcAmpsInput);
            setNumberAttribute(olcAmpsInput, resultAmps);
            setNumberAttribute(olcOhmsInput, resultOhms);
            console.log('calculando ohms amps');
        } 
        else if (!isNaN(ohms) && !isNaN(watts) && isNaN(amps) && isNaN(volts)) {
            let resultVolts = Math.sqrt(watts * ohms).toFixed(4);
            let resultAmps = Math.sqrt(watts / ohms).toFixed(4);
            olcVoltsInput.value = resultVolts;
            olcAmpsInput.value = resultAmps;
            hiddeLabelToltip(olcAmpsInput);
            hiddeLabelToltip(olcVoltsInput);
            setNumberAttribute(olcVoltsInput, resultVolts);
            setNumberAttribute(olcAmpsInput, resultAmps);
            console.log('calculando volts amps');
        } 
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                let resultVolts = Math.sqrt(watts * ohms).toFixed(4);
                let resultAmps = Math.sqrt(watts / ohms).toFixed(4);
                olcVoltsInput.value = resultVolts;
                olcAmpsInput.value = resultAmps;
                hiddeLabelToltip(olcAmpsInput);
                hiddeLabelToltip(olcVoltsInput);
                setNumberAttribute(olcAmpsInput, resultAmps);
                setNumberAttribute(olcVoltsInput, resultVolts);
                console.log('calculando volts amps');
            }else if(lastInput == 'amps'){
                let resultVolts = (watts / amps).toFixed(4);
                let resultOhms = (watts / (amps ** 2)).toFixed(4);
                olcVoltsInput.value = resultVolts;
                olcOhmsInput.value = resultOhms;
                hiddeLabelToltip(olcOhmsInput);
                hiddeLabelToltip(olcVoltsInput);
                setNumberAttribute(olcOhmsInput, resultOhms);
                setNumberAttribute(olcVoltsInput, resultVolts);
                console.log('calculando volts ohms');
            }else if(lastInput == 'volts'){
                let resultOhms = (volts ** 2 / watts).toFixed(4);
                let resultAmps = (watts / volts).toFixed(4);
                olcOhmsInput.value = resultOhms;
                olcAmpsInput.value = resultAmps;
                hiddeLabelToltip(olcAmpsInput);
                hiddeLabelToltip(olcOhmsInput);
                setNumberAttribute(olcOhmsInput, resultOhms);
                setNumberAttribute(olcAmpsInput, resultAmps);
                console.log('calculando ohms amps');
            }
             
        }
        lastInput = 'watts';
    })

    btnReset.addEventListener('click', e=>{
        customReset(formOlc);
    })
    
    formOlc.addEventListener('submit', e => {
      e.preventDefault(); 
    });
}

const ohmsCalculator2 = (formOlc, olcOhmsInput, olcVoltsInput, olcAmpsInput, olcWattsInput, btnReset) => {
    console.log('calculadora 2 test');
    let lastInput = '';
    let penultimateInput = ''
    const onlyThisIsNumber = (thisInput) =>{
        let inputs = formOlc.querySelectorAll('input');
        let arrayInputs = [];
        let inputsCounter = 0;
        inputs.forEach(input => {
            if(thisInput.getAttribute('name') != input.getAttribute('name')){
                arrayInputs.push(input);
            }
        });
        arrayInputs.forEach(input=>{
            if(!isNaN(input.value) && input.value != ''){
                //console.log(input.value);
                //console.log(input);
                inputsCounter++;
            }
        });
        if(inputsCounter > 0){
            //console.log(arrayInputs);
            return false;
        }else{
            //console.log(arrayInputs);
            //console.log('solo este es numero');
            return true;
        }
    }
    console.log('test');
    const calculateVoltsAmpsWithOhmsWatts = (ohms, watts) =>{
        let resultVolts = Math.sqrt(watts * ohms);
        let resultAmps = Math.sqrt(watts / ohms);
        if(!isNaN(resultVolts)){
            olcVoltsInput.value = resultVolts.toFixed(4);
        };
        if(!isNaN(resultAmps)){
            olcAmpsInput.value = resultAmps.toFixed(4);
        }
        hiddeLabelToltip(olcVoltsInput);
        hiddeLabelToltip(olcAmpsInput);
        setNumberAttribute(olcVoltsInput, resultVolts);
        setNumberAttribute(olcAmpsInput, resultAmps);
        console.log('calculando volts amps');
        console.log('ohms ' + ohms);
        console.log('watts' + watts);
    }
    const calculateVoltsWattsWithOhmsAmps = (ohms, amps) =>{
        let resultVolts = (amps * ohms);
        let resultWatts = (amps ** 2 * ohms);
        if(!isNaN(resultVolts)){
            olcVoltsInput.value = resultVolts.toFixed(4);
        };
        if(!isNaN(resultWatts)){
            olcWattsInput.value = resultWatts.toFixed(4);
        }
        hiddeLabelToltip(olcVoltsInput);
        hiddeLabelToltip(olcWattsInput);
        setNumberAttribute(olcVoltsInput, resultVolts);
        setNumberAttribute(olcWattsInput, resultWatts);
        console.log('calculando volts watts');
        console.log('ohms '+ ohms);
        console.log('amps '+ amps);
    }
    const calculateAmpsWattsWithOhmsVolts = (ohms, volts) =>{ //revisar
        ohms = parseFloat(ohms);
        volts = parseFloat(volts);
        let resultAmps = (volts / ohms);
        let resultWatts = (volts ** 2 / ohms);
        if(!isNaN(resultAmps)){
            olcAmpsInput.value = resultAmps.toFixed(4);
        };
        if(!isNaN(resultWatts)){
            olcWattsInput.value = resultWatts.toFixed(4);
        }
        hiddeLabelToltip(olcAmpsInput);
        hiddeLabelToltip(olcWattsInput);
        setNumberAttribute(olcAmpsInput, resultAmps);
        setNumberAttribute(olcWattsInput, resultWatts);
        console.log('calculando Amps watts');
        console.log('ohms '+ohms);
        console.log('volts test' + volts);
    }
    const calculateOhmsWattsWithVoltsAmps = (volts, amps) =>{ //verificado
        let resultOhms = (volts / amps).toFixed(4);
        let resultWatts =(volts * amps).toFixed(4);
        if(!isNaN(resultOhms)){
            olcOhmsInput.value = resultOhms;
        };
        if(!isNaN(resultWatts)){
            olcWattsInput.value = resultWatts;
        }
        hiddeLabelToltip(olcOhmsInput);
        hiddeLabelToltip(olcWattsInput);
        setNumberAttribute(olcOhmsInput, resultOhms);
        setNumberAttribute(olcWattsInput, resultWatts);
        console.log('calculando ohms watts');
        console.log('volts '+volts);
        console.log('amps ' + amps);
    }
    
    const calculateOhmsAmpsWithVoltsWatts = (volts, watts) =>{
        let resultOhms = (volts ** 2 / watts).toFixed(4);
        let resultAmps = (watts / volts).toFixed(4);
        if(!isNaN(resultOhms)){
            olcOhmsInput.value = resultOhms;
        };
        if(!isNaN(resultAmps)){
            olcAmpsInput.value = resultAmps;
        }
        hiddeLabelToltip(olcOhmsInput);
        hiddeLabelToltip(olcAmpsInput);
        setNumberAttribute(olcOhmsInput, resultOhms);
        setNumberAttribute(olcAmpsInput, resultAmps);
        console.log('calculando ohms amps');
        console.log('volts ' + volts);
        console.log('watts' + watts);
    }
    const calculateOhmsVoltsWithWattsAmps = (amps, watts) =>{
        let resultVolts = (watts / amps).toFixed(4);
        let resultOhms = (watts / (amps ** 2)).toFixed(4);
        if(!isNaN(resultVolts)){
            olcVoltsInput.value = resultVolts;
        };
        if(!isNaN(resultOhms)){
            olcOhmsInput.value = resultOhms;
        }
        hiddeLabelToltip(olcVoltsInput);
        hiddeLabelToltip(olcOhmsInput);
        setNumberAttribute(olcVoltsInput, resultVolts);
        setNumberAttribute(olcOhmsInput, resultOhms);
        console.log('calculando volts ohms');
        console.log('amps ' + amps);
        console.log('watts ' + watts);
    }
    olcOhmsInput.addEventListener('input', e=>{
        setNumberAttribute(olcOhmsInput, olcOhmsInput.value);
        let thisInput = 'ohms';
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }
        console.log(lastInput);
        //calcular todos menos ohms

        if (!isNaN(ohms) && !isNaN(watts) && isNaN(volts) && isNaN(amps)) {
            //calcular volts y amps
            calculateVoltsAmpsWithOhmsWatts(ohms, watts);
        } else if (!isNaN(ohms) && !isNaN(amps)  && isNaN(volts) && isNaN(watts)) {
            //calcular volts y watts
            calculateVoltsWattsWithOhmsAmps(ohms, amps);

        } else if (!isNaN(ohms) && !isNaN(volts) && isNaN(amps) && isNaN(watts)) {
            //calcular amps y watts
            calculateAmpsWattsWithOhmsVolts(ohms, volts);

        }
        //si volt esta vacio
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }

        }
        //si ohms esta vacio
        else if (isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }

        }
        //si amps esta vacio 
        else if (!isNaN(ohms) && isNaN(amps) && !isNaN(watts) && !isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }

        }
        //si whatts esta vacio
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && !isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }


        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)) {
            //calcular cualquiera que no se haya de ultimo
            if(lastInput == 'volts'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts);
            }else if(lastInput == 'watts'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts);
            }else if(lastInput == 'amps'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }

        }

    })
    olcVoltsInput.addEventListener('input', e=>{
        //console.log('escribiendo volts');
        setNumberAttribute(olcVoltsInput, olcVoltsInput.value);
        let thisInput = 'volts';
        console.log(lastInput);

        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }
        if (!isNaN(volts) && !isNaN(amps) && isNaN(ohms) && isNaN(watts)) {
            //calculateOhmsWattsWithVoltsAmps(volts, amps);
            calculateOhmsWattsWithVoltsAmps(volts, amps)
        } 
        else if (!isNaN(volts) && !isNaN(watts) && isNaN(ohms) && isNaN(amps)) {
            //calculateOhmsAmpsWithVoltsWatts(volts, watts);
            calculateOhmsAmpsWithVoltsWatts(volts, watts)
        } 
        else if (!isNaN(ohms) && !isNaN(volts) && isNaN(watts) && isNaN(amps)) {
            console.log('primera vez');
            console.log(volts);
            calculateAmpsWattsWithOhmsVolts(ohms, volts)
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                console.log('segunda vez');
                calculateAmpsWattsWithOhmsVolts(ohms, volts)
                console.log(volts);
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts)
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts)
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts)
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            } 
        }
        else if (!isNaN(ohms) && isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts)
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts)
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts)
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts)
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateAmpsWattsWithOhmsVolts(ohms, volts)
            }else if(lastInput == 'watts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts)
            }else if(lastInput == 'amps'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }    
        }
    })
    olcAmpsInput.addEventListener('input',e=>{
        setNumberAttribute(olcAmpsInput, olcAmpsInput.value);
        let thisInput = 'amps';

        console.log(lastInput);
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }
        if (!isNaN(volts) && !isNaN(amps) && isNaN(ohms) && isNaN(watts)) {
            calculateOhmsWattsWithVoltsAmps(volts, amps);
        } 
        else if (!isNaN(watts) && !isNaN(amps) && isNaN(ohms) && isNaN(volts)) {
            calculateOhmsVoltsWithWattsAmps(amps, watts)
        } 
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && isNaN(volts)) {
            calculateVoltsWattsWithOhmsAmps(ohms, amps)
        } 
        else if (isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
             
        }
        else if (!isNaN(ohms) && isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsWattsWithOhmsAmps(ohms, amps)
            }else if(lastInput == 'watts'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsWattsWithVoltsAmps(volts, amps)
            }    
        }
    })
    olcWattsInput.addEventListener('input', e=>{
        setNumberAttribute(olcWattsInput, olcWattsInput.value);
        let thisInput = 'watts';

        console.log(lastInput);
        let ohms = parseFloat(olcOhmsInput.getAttribute('data-number'));
        let volts = parseFloat(olcVoltsInput.getAttribute('data-number'));
        let amps = parseFloat(olcAmpsInput.getAttribute('data-number'));
        let watts = parseFloat(olcWattsInput.getAttribute('data-number'));
        if(isNaN(ohms)){
            ohms = parseFloat(olcOhmsInput.value);
        };
        if(isNaN(volts)){
            volts = parseFloat(olcVoltsInput.value);
        };
        if(isNaN(amps)){
            amps = parseFloat(olcAmpsInput.value);
        };
        if(isNaN(watts)){
            watts = parseFloat(olcWattsInput.value);
        }
        if (!isNaN(watts) && !isNaN(amps) && isNaN(ohms) && isNaN(volts)) {
            calculateOhmsVoltsWithWattsAmps(amps, watts);
        } 
        else if (!isNaN(volts) && !isNaN(watts) && isNaN(ohms) && isNaN(amps)) {
            calculateOhmsAmpsWithVoltsWatts(volts, watts);
        } 
        else if (!isNaN(ohms) && !isNaN(watts) && isNaN(amps) && isNaN(volts)) {
            calculateVoltsAmpsWithOhmsWatts(ohms, watts);
        } 
        else if (isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts) 
            }else if(lastInput == 'amps'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts);
            }
        }
        else if (!isNaN(ohms) && isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts) 
            }else if(lastInput == 'amps'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts);
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts) 
            }else if(lastInput == 'amps'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts);
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts) 
            }else if(lastInput == 'amps'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts);
            }
        }
        else if (!isNaN(ohms) && !isNaN(amps) && !isNaN(watts) && !isNaN(volts)){
            if(lastInput == 'ohms'){
                calculateVoltsAmpsWithOhmsWatts(ohms, watts) 
            }else if(lastInput == 'amps'){
                calculateOhmsVoltsWithWattsAmps(amps, watts);
            }else if(lastInput == 'volts'){
                calculateOhmsAmpsWithVoltsWatts(volts, watts);
            }    
        }
    })
    olcOhmsInput.addEventListener('blur', e=>{
        lastInput = 'ohms';
    })
    olcVoltsInput.addEventListener('blur', e=>{
        lastInput = 'volts';
    })
    olcAmpsInput.addEventListener('blur', e=>{
        lastInput = 'amps';
    })
    olcWattsInput.addEventListener('blur', e=>{
        lastInput = 'watts';
    })
    btnReset.addEventListener('click', e=>{
        customReset(formOlc);
    })
    
    formOlc.addEventListener('submit', e => {
      e.preventDefault(); 
    });
}

const sToACalculator = (formSa, saSCFMInput, saPInput, saTInput, saACFMResultInput, saBtnReset) => {


    const calculateValues = () => {
        let scfm = parseFloat(saSCFMInput.getAttribute('data-number'));
        let p = parseFloat(saPInput.getAttribute('data-number'));
        let t = parseFloat(saTInput.getAttribute('data-number'));
        if (isNaN(scfm)) {
            scfm = parseFloat(saSCFMInput.value);
        };
        if (isNaN(p)) {
            p = parseFloat(saPInput.value);
        };
        if (isNaN(t)) {
            t = parseFloat(saTInput.value);
        };

        if (!isNaN(scfm) && !isNaN(p) && !isNaN(t)) {
            const acfm = scfm * ((460 + t) / 530) * (14.7 / (14.7 + p));
            if (!isNaN(acfm)) {
                saACFMResultInput.value = acfm.toFixed(4);
                hiddeLabelToltip(saACFMResultInput);
                hiddeLabelToltip(saACFMResultInput);
                saACFMResultInput.setAttribute('data-number', acfm);
            } else {
                saACFMResultInput.value = '';
            }
        }
    };

    formSa.addEventListener('input', e => {
        calculateValues();
    });

    formSa.addEventListener('submit', e => {
        e.preventDefault();
        calculateValues();
    });

    saBtnReset.addEventListener('click', e => {
        customReset(formSa);
        saACFMResultInput.value = '';
    });
}
const asCalculator = (formAs, asACFMInput, asPInput, asTInput, asSCFMResultInput, asBtnReset) => {

    const calculateValues = () => {
        let acfm = parseFloat(asACFMInput.getAttribute('data-number'));
        let p = parseFloat(asPInput.getAttribute('data-number'));
        let t = parseFloat(asTInput.getAttribute('data-number'));
        if (isNaN(acfm)) {
            acfm = parseFloat(asACFMInput.value);
        };
        if (isNaN(p)) {
            p = parseFloat(asPInput.value);
        };
        if (isNaN(t)) {
            t = parseFloat(asTInput.value);
        };

        if (!isNaN(acfm) && !isNaN(p) && !isNaN(t)) {
            //const scfm = acfm / (((460 + t) / 530) * (14.7 / (14.7 + p)));
            const scfm = acfm / (t / 528 * 14.7 / (14.7 + p));
            if (!isNaN(scfm)) {
                asSCFMResultInput.value = scfm.toFixed(2);
                hiddeLabelToltip(asSCFMResultInput);
                asSCFMResultInput.setAttribute('data-number', scfm);
            } else {
                asSCFMResultInput.value = '';
            }
        }
    };

    formAs.addEventListener('input', e=>{
        calculateValues();
    });
    formAs.addEventListener('submit', e=>{
        e.preventDefault();
        calculateValues();
    });

    asBtnReset.addEventListener('click', e=>{
        customReset(formAs);
        asSCFMResultInput.value = '';
    });
}
const mfvmfCalculator = (form)=>{
    console.log(form);
    let btnReset = form.querySelector('.btn-reset');
    let inputs = form.querySelectorAll('input');
    let kghInput = form.elements['kg/h'];
    let lbsminInput = form.elements['lbs/min'];
    let scfmInput = form.elements['scfm']
    const calculateValues = ()=>{
        let kgh = parseFloat(kghInput.getAttribute('data-number')) || parseFloat(kghInput.value);
        let lbsmin = parseFloat(lbsminInput.getAttribute('data-number')) || parseFloat(lbsminInput.value);
        let scfm = parseFloat(scfmInput.getAttribute('data-number')) || parseFloat(scfmInput.value);
        console.log('calculando');
        if(isNaN(kgh)){
            kgh = parseFloat(kghInput.value);
        };
        if(isNaN(lbsmin)){
            lbsmin = parseFloat(lbsminInput.value);
        };
        if(isNaN(scfm)){
            scfm = parseFloat(scfmInput.value);
        };
        if(!isNaN(kgh)){
            console.log(kgh);
            if(isNaN(lbsmin)){
                console.log('calculando lbs/min y scfm');
                const calculateLbsmin = (0.0367437673384652) * kgh;
                const calculateScfm = (13.2978723404) * calculateLbsmin;
                lbsminInput.value = calculateLbsmin.toFixed(2);
                scfmInput.value = calculateScfm.toFixed(2);
                hiddeLabelToltip(lbsminInput);
                hiddeLabelToltip(scfmInput);
                lbsminInput.setAttribute('data-number', calculateLbsmin);
                scfmInput.setAttribute('data-number', calculateScfm);
            }
        }else if (!isNaN(lbsmin)){
            if(isNaN(kgh)){
                console.log('calculando lbs/min y scfm');
                const calculateKgh = lbsmin / 0.0367437673384652;
                const calculateScfm = (13.2978723404) * lbsmin;
                kghInput.value = calculateKgh.toFixed(2);
                scfmInput.value = calculateScfm.toFixed(2);
                hiddeLabelToltip(kghInput);
                hiddeLabelToltip(scfmInput);
                kghInput.setAttribute('data-number', calculateKgh);
                scfmInput.setAttribute('data-number', calculateScfm);
            }
        }
    }
    const clearInput = (input)=>{
        input.value = '';
        showLabelToltip(input);
        input.setAttribute('data-number', '');
    }
    form.addEventListener('submit', e=>{
        e.preventDefault();
        calculateValues();
    })
    btnReset.addEventListener('click', e=>{
        customReset(form);
    })
    
    kghInput.addEventListener('input', e=>{
        clearInput(lbsminInput);
    })
    lbsminInput.addEventListener('input', e=>{
        clearInput(kghInput);
    })

    
}
  
window.addEventListener('load', e=>{
    const formpfrt = document.getElementById('pfrt-calculator');
    const pfrtBtnCalculate = document.querySelector('#pfrt-btn');
    const pfrtSCFMInput = document.getElementById('pfrt-SCFM');
    const pfrtΔTInput = document.getElementById('pfrt-ΔT');
    const pfrtWattsInput = document.getElementById('pfrt-Watts');
    const pfrtBtnReset = document.getElementById('pfrt-reset');
    const formpfrtF = document.getElementById('pfrt-calculator-f');
    const pfrtSCFMInputF = document.getElementById('pfrt-SCFM-f');
    const pfrtΔTInputF = document.getElementById('pfrt-ΔT-f');
    const pfrtWattsInputF = document.getElementById('pfrt-Watts-f');
    const pfrtBtnResetF = document.getElementById('pfrt-reset-f');
    pfrtCalculator(formpfrtF, pfrtSCFMInputF, pfrtΔTInputF, pfrtWattsInputF, pfrtBtnResetF);
    pfrtCalculator(formpfrt, pfrtSCFMInput, pfrtΔTInput, pfrtWattsInput, pfrtBtnReset);
    const formtc = document.getElementById('tc-calculator');
    const tcFInput = document.getElementById('tc-f');
    const tcCInput = document.getElementById('tc-c');
    const tcBtnReset = document.getElementById('tc-reset');
    const formtcf = document.getElementById('tc-calculator-f');
    const tcFInputf = document.getElementById('tc-f-f');
    const tcCInputf = document.getElementById('tc-c-f');
    const tcBtnResetf = document.getElementById('tc-reset-f');
    tcCalculator(formtcf, tcFInputf, tcCInputf, tcBtnResetf);
    tcCalculator(formtc, tcFInput, tcCInput, tcBtnReset);
    const formtpuc = document.getElementById('tpuc-calculator');
    const tpucWattsInput = document.getElementById('tpuc-whats');
    const tpucVoltageInput = document.getElementById('tpuc-voltage');
    const tpucLineCurrentInput = document.getElementById('tpuc-line-current');
    const tpucBtnReset = document.getElementById('tpuc-reset');
    const formtpucF = document.getElementById('tpuc-calculator-f');
    const tpucWattsInputF = document.getElementById('tpuc-whats-f');
    const tpucVoltageInputF = document.getElementById('tpuc-voltage-f');
    const tpucLineCurrentInputF = document.getElementById('tpuc-line-current-f');
    const tpucBtnResetF = document.getElementById('tpuc-reset-f');
    tpucCalculator(formtpucF, tpucWattsInputF, tpucVoltageInputF, tpucLineCurrentInputF, tpucBtnResetF);
    tpucCalculator(formtpuc, tpucWattsInput, tpucVoltageInput, tpucLineCurrentInput, tpucBtnReset);
    const formspuc = document.getElementById('spuc-calculator');
    const spucWattsInput = document.getElementById('spuc-whats');
    const spucVoltageInput = document.getElementById('spuc-voltage');
    const spucLineCurrentInput = document.getElementById('spuc-line-current');
    const spucBtnReset = document.getElementById('spuc-reset');
    const formspucF = document.getElementById('spuc-calculator-f');
    const spucWattsInputF = document.getElementById('spuc-whats-f');
    const spucVoltageInputF = document.getElementById('spuc-voltage-f');
    const spucLineCurrentInputF = document.getElementById('spuc-line-current-f');
    const spucBtnResetF = document.getElementById('spuc-reset-f');
    spucCalculator(formspucF, spucWattsInputF, spucVoltageInputF, spucLineCurrentInputF, spucBtnResetF);
    spucCalculator(formspuc, spucWattsInput, spucVoltageInput, spucLineCurrentInput, spucBtnReset);
    const formhttc = document.getElementById('httc-calculator');
    const httcDensityInput = document.getElementById('httc-p');
    const httcVolumeInput = document.getElementById('httc-v');
    const httcSpecificHeatInput = document.getElementById('httc-cp');
    const httcTemperatureDiffInput = document.getElementById('httc-Ta-Tb');
    const httcQInput = document.getElementById('httc-q');
    const httcBtnReset = document.getElementById('httc-reset');
    const formhttcF = document.getElementById('httc-calculator-f');
    const httcDensityInputF = document.getElementById('httc-p-f');
    const httcVolumeInputF = document.getElementById('httc-v-f');
    const httcSpecificHeatInputF = document.getElementById('httc-cp-f');
    const httcTemperatureDiffInputF = document.getElementById('httc-Ta-Tb-f');
    const httcQInputF = document.getElementById('httc-q-f');
    const httcBtnResetF = document.getElementById('httc-reset-f');
    httcCalculator(formhttcF, httcDensityInputF, httcVolumeInputF, httcSpecificHeatInputF, httcTemperatureDiffInputF, httcQInputF, httcBtnResetF);
    httcCalculator(formhttc, httcDensityInput, httcVolumeInput, httcSpecificHeatInput, httcTemperatureDiffInput, httcQInput, httcBtnReset);
    const formsfr = document.getElementById('sfr-calculator');
    const sfrCFMInput = document.getElementById('sfr-cfm');
    const sfrPSIInput = document.getElementById('sfr-psi');
    const sfrTInput = document.getElementById('sfr-t');
    const sfrSCFMInput = document.getElementById('sfr-scfm');
    const sfrBtnReset = document.getElementById('sfr-reset');
    const formsfrF = document.getElementById('sfr-calculator-f');
    const sfrCFMInputF = document.getElementById('sfr-cfm-f');
    const sfrPSIInputF = document.getElementById('sfr-psi-f');
    const sfrTInputF = document.getElementById('sfr-t-f');
    const sfrSCFMInputF = document.getElementById('sfr-scfm-f');
    const sfrBtnResetF = document.getElementById('sfr-reset-f');
    sfrCalculator(formsfrF, sfrCFMInputF, sfrPSIInputF, sfrTInputF, sfrSCFMInputF, sfrBtnResetF);
    sfrCalculator(formsfr, sfrCFMInput, sfrPSIInput, sfrTInput, sfrSCFMInput, sfrBtnReset);
    const formPb = document.getElementById('pb-calculator');
    const pbPSIInput = document.getElementById('pb-psi');
    const pbBarInput = document.getElementById('pb-bar');
    const pbBtnReset = document.getElementById('pb-reset');
    const formPbF = document.getElementById('pb-calculator-f');
    const pbPSIInputF = document.getElementById('pb-psi-f');
    const pbBarInputF = document.getElementById('pb-bar-f');
    const pbBtnResetF = document.getElementById('pb-reset-f');
    pressureConverter(formPbF, pbPSIInputF, pbBarInputF, pbBtnResetF);
    pressureConverter(formPb, pbPSIInput, pbBarInput, pbBtnReset);
    const formOlc = document.getElementById('olc-calculator');
    const olcOhmsInput = document.getElementById('olc-ohms');
    const olcVoltsInput = document.getElementById('olc-volts');
    const olcAmpsInput = document.getElementById('olc-amps');
    const olcWattsInput = document.getElementById('olc-whats');
    const btnReset = document.getElementById('olc-reset');
    const formOlcF = document.getElementById('olc-calculator-f');
    const olcOhmsInputF = document.getElementById('olc-ohms-f');
    const olcVoltsInputF = document.getElementById('olc-volts-f');
    const olcAmpsInputF = document.getElementById('olc-amps-f');
    const olcWattsInputF = document.getElementById('olc-whats-f');
    const btnResetF = document.getElementById('olc-reset-f');
    ohmsCalculator2(formOlcF, olcOhmsInputF, olcVoltsInputF, olcAmpsInputF, olcWattsInputF, btnResetF);
    ohmsCalculator2(formOlc, olcOhmsInput, olcVoltsInput, olcAmpsInput, olcWattsInput, btnReset);
    const formSa = document.getElementById('sa-form');
    const saSCFMInput = document.getElementById('sa-scfm');
    const saPInput = document.getElementById('sa-p');
    const saTInput = document.getElementById('sa-t');
    const saACFMResultInput = document.getElementById('sa-acfm');
    const saBtnReset = document.getElementById('sa-reset');
    const formSaF = document.getElementById('sa-form-f');
    const saSCFMInputF = document.getElementById('sa-scfm-f');
    const saPInputF = document.getElementById('sa-p-f');
    const saTInputF = document.getElementById('sa-t-f');
    const saACFMResultInputF = document.getElementById('sa-acfm-f');
    const saBtnResetF = document.getElementById('sa-reset-f');
    //sToACalculator(formSaF, saSCFMInputF, saPInputF, saTInputF, saACFMResultInputF, saBtnResetF);
    //sToACalculator(formSa, saSCFMInput, saPInput, saTInput, saACFMResultInput, saBtnReset);
    const formAs = document.getElementById('as-form');
    const asACFMInput = document.getElementById('as-acfm');
    const asPInput = document.getElementById('as-p');
    const asTInput = document.getElementById('as-t');
    const asSCFMResultInput = document.getElementById('as-scfm');
    const asBtnReset = document.getElementById('as-reset');
    const formAsF = document.getElementById('as-form-f');
    const asACFMInputF = document.getElementById('as-acfm-f');
    const asPInputF = document.getElementById('as-p-f');
    const asTInputF = document.getElementById('as-t-f');
    const asSCFMResultInputF = document.getElementById('as-scfm-f');
    const asBtnResetF = document.getElementById('as-reset-f');
    asCalculator(formAs, asACFMInput, asPInput, asTInput, asSCFMResultInput, asBtnReset);
    asCalculator(formAs, asACFMInput, asPInput, asTInput, asSCFMResultInput, asBtnReset);

    let calculatorsmfvmf = document.querySelectorAll('.calculator-mfvmf');
    calculatorsmfvmf.forEach(calculator=>{
        let form = calculator.querySelector('form');
        mfvmfCalculator(form);
    })
    let calculatorsmfvmfShortcode = document.querySelectorAll('.calculator_mfvmf');
    calculatorsmfvmfShortcode.forEach(calculator=>{
        let form = calculator.querySelector('form');
        mfvmfCalculator(form);
    })

    let calculatorsShortcode = document.querySelectorAll('.calculator_shortcode');
    calculatorsShortcode.forEach(calculator=>{
        console.log(calculator);
        let formCalculator = calculator.querySelector('form');
        let btnReset = calculator.querySelector('.btn-reset');
        //let F = formCalculator.elements['f'].value;
        if(calculator.classList.contains('calculator_pfrt')){
            let scfm = formCalculator.elements['SCFM'];
            let at = formCalculator.elements['ΔT'];
            let whats = formCalculator.elements['Watts'];
            pfrtCalculator(formCalculator, scfm, at, whats, btnReset);
        }
        if(calculator.classList.contains('calculator_tc')){
            let f = formCalculator.elements['f'];
            let c = formCalculator.elements['c'];
            tcCalculator(formCalculator, f, c, btnReset);
        }
        if(calculator.classList.contains('calculator_tpuc')){
            let whats = formCalculator.elements['whats'];
            let voltage = formCalculator.elements['voltage'];
            let lc = formCalculator.elements['line-current'];
            tpucCalculator(formCalculator, whats, voltage, lc, btnReset);
        }
        if(calculator.classList.contains('calculator_spuc')){
            let whats = formCalculator.elements['whats'];
            let voltage = formCalculator.elements['voltage'];
            let lc = formCalculator.elements['line-current'];
            spucCalculator(formCalculator, whats, voltage, lc, btnReset);
        }
        if(calculator.classList.contains('calculator_olc')){
            let ohms = formCalculator.elements['ohms'];
            let volts = formCalculator.elements['volts'];
            let amps = formCalculator.elements['amps'];
            let whats = formCalculator.elements['whats'];
            ohmsCalculator2(formCalculator, ohms, volts, amps, whats, btnReset);
        }
        if(calculator.classList.contains('calculator_httc')){
            let p = formCalculator.elements['p'];
            let v = formCalculator.elements['v'];
            let cp = formCalculator.elements['cp'];
            let tatb = formCalculator.elements['Ta-Tb'];
            httcCalculator(formCalculator, p, v, cp, tatb, httcQInput, btnReset);
        }
        if(calculator.classList.contains('calculator_sa')){
            let SCFM = formCalculator.elements['SCFM'];
            let p = formCalculator.elements['p'];
            let t = formCalculator.elements['t'];
            let acfm = formCalculator.elements['acfm'];
            sToACalculator(formCalculator, SCFM, p, t, acfm, btnReset);
        }
        if(calculator.classList.contains('calculator_as')){
            let SCFM = formCalculator.elements['scfm'];
            let p = formCalculator.elements['p'];
            let t = formCalculator.elements['t'];
            let acfm = formCalculator.elements['acfm'];
            asCalculator(formCalculator, acfm, p, t, SCFM, btnReset);
        }
        if(calculator.classList.contains('calculator_sfr')){
            let cfm = formCalculator.elements['cfm'];
            let psi = formCalculator.elements['psi'];
            let t = formCalculator.elements['t'];
            let scfm = formCalculator.elements['scfm'];
            sfrCalculator(formCalculator, cfm, psi, t, scfm, btnReset);
        }
        if(calculator.classList.contains('calculator_pb')){
            let psi = formCalculator.elements['psi'];
            let bar = formCalculator.elements['bar'];
            pressureConverter(formCalculator, psi, bar, btnReset);
        }
    }) 
})